import { useState, useRef, useEffect } from "react";
import relevant from "../../assets/shapes_svg/feed/relevant.svg";
import notrelevant from "../../assets/shapes_svg/feed/notrelevant.svg";
import save from "../../assets/shapes_svg/course/save.svg";
import "../../components/Course/index.css";
import { addFeedLike } from "../../apis/Feed";
import { useInvalidateQuery } from "../../components/InvalidateQueryContext";
const FeedComponent = ({
  click,
  feed,
  chosen,
  likedFeedsLists,
  isChosen,
  handleRemoveChosen,
}) => {
  function useHover() {
    const [value, setValue] = useState(false);
    const ref = useRef(null);
    const handleMouseOver = () => setValue(true);
    const handleMouseOut = () => setValue(false);
    useEffect(
      () => {
        const node = ref.current;
        if (node) {
          node.addEventListener("mouseover", handleMouseOver);
          node.addEventListener("mouseout", handleMouseOut);
          return () => {
            node.removeEventListener("mouseover", handleMouseOver);
            node.removeEventListener("mouseout", handleMouseOut);
          };
        }
      },
      [ref.current] // Recall only if ref changes
    );
    return [ref, value];
  }
  const [hoverRef, isHovered] = useHover();
  const [hoverRef2, isHovered2] = useHover();
  const { triggerInvalidate } = useInvalidateQuery();

  const handleAddFeedLike = (feedId) => {
    addFeedLike({ feed_id: feedId, triggerInvalidate: triggerInvalidate });
  };
  return (
    <div
      className={
        "suggestedcourse d-flex flex-column justify-content-center align-items-center "
      }
      style={{ height: "460px", cursor: "pointer", zIndex: "20" }}
    >
      {/* <a className="nav-link d-flex flex-column justify-content-center align-items-center" href={link} target="_blank" > */}
      <div className="suggestedcourse__wrapper feed__wrapper">
        <h4>{feed.types ? feed.types[0] : ""}</h4>
      </div>

      <div
        className={
          "suggestedcourse__item feed__item " +
          (chosen ? "selected__feed__body" : "")
        }
        style={{ marginTop: 0, paddingTop: 0 }}
        onClick={click}
      >
        {/* <img src={bg} className="w-100 h-100" alt="" style={{height:"108%",border:"1px solid black"}}/> */}
        <img
          src={save}
          alt=""
          style={{
            position: "absolute",
            left: "-2%",
            top: "-2%",
            opacity:
              likedFeedsLists &&
              likedFeedsLists.length > 0 &&
              likedFeedsLists.includes(feed.id)
                ? "1"
                : "0.5",
            zIndex: "5",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleAddFeedLike(feed.id);
          }}
        />
        {isChosen && (
          <img
            src={notrelevant}
            alt=""
            style={{
              position: "absolute",
              right: "-2%",
              top: "-2%",
              zIndex: "5",
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveChosen(feed.id);
            }}
          />
        )}
        <div className="suggestedcourse__title">
          <h3>{feed.title}</h3>
          <h4>{feed.summary.substring(0, 100)}...</h4>
        </div>
      </div>
      <div className="suggestedcourse__buttons">
        <div
          className="suggestedcourse__button feed__button"
          style={{ alignItems: "flex-end" }}
        >
          <img
            src={relevant}
            alt=""
            ref={hoverRef}
            onClick={() => handleAddFeedLike(feed.id)}
            style={{ zIndex: "5" }}
          />
          <h4 style={{ opacity: isHovered ? 1 : 0, transition: "all 0.4s" }}>
            Relevant
          </h4>
        </div>
        <div
          className="suggestedcourse__button feed__button"
          style={{ alignItems: "flex-start" }}
        >
          <img src={notrelevant} alt="" ref={hoverRef2} />
          <h4 style={{ opacity: isHovered2 ? 1 : 0 }}>Not Relevant</h4>
        </div>
      </div>
      {/* </a> */}
    </div>
  );
};

export default FeedComponent;
